/**
 * API error codes the backend attaches to `ApiError` instances and the frontend
 * switches on for user-facing messaging. Single source of truth — see
 * `@orn/core/utils/errors.ts` for the runtime `ApiError` class that wraps these.
 */
export enum ApiErrorCode {
  // Plaid/Banking errors
  DUPLICATE_ITEM = 'DUPLICATE_ITEM',
  PLAID_LINK_TOKEN_FAILED = 'PLAID_LINK_TOKEN_FAILED',
  PLAID_EXCHANGE_FAILED = 'PLAID_EXCHANGE_FAILED',

  // Auth errors
  AUTH_INVALID_CREDENTIALS = 'AUTH_INVALID_CREDENTIALS',
  AUTH_RATE_LIMITED = 'AUTH_RATE_LIMITED',
  AUTH_INVALID_OTP = 'AUTH_INVALID_OTP',
  AUTH_OTP_EXPIRED = 'AUTH_OTP_EXPIRED',
  AUTH_ACCOUNT_SUSPENDED = 'AUTH_ACCOUNT_SUSPENDED',
  AUTH_PROVIDER_CONFLICT = 'AUTH_PROVIDER_CONFLICT',
  AUTH_PENDING_VERIFICATION = 'AUTH_PENDING_VERIFICATION',
  AUTH_INVALID_EMAIL = 'AUTH_INVALID_EMAIL',
  AUTH_WEAK_PASSWORD = 'AUTH_WEAK_PASSWORD',
  AUTH_RESEND_LIMIT = 'AUTH_RESEND_LIMIT',
  AUTH_EMAIL_ALREADY_REGISTERED = 'AUTH_EMAIL_ALREADY_REGISTERED',
  AUTH_INVALID_SMS_OTP = 'AUTH_INVALID_SMS_OTP',
  AUTH_SMS_RATE_LIMITED = 'AUTH_SMS_RATE_LIMITED',
  AUTH_NOT_ON_ALPHA_ALLOW_LIST = 'AUTH_NOT_ON_ALPHA_ALLOW_LIST',
  AUTH_INVALID_FIRST_NAME = 'AUTH_INVALID_FIRST_NAME',
  AUTH_INVALID_LAST_NAME = 'AUTH_INVALID_LAST_NAME',
  AUTH_INVALID_PREFERRED_NAME = 'AUTH_INVALID_PREFERRED_NAME',

  // SMS verification errors
  SMS_COOLDOWN = 'SMS_COOLDOWN',
  SMS_DAILY_LIMIT = 'SMS_DAILY_LIMIT',
  SMS_NO_PHONE_NUMBER = 'SMS_NO_PHONE_NUMBER',
  SMS_INVALID_CODE = 'SMS_INVALID_CODE',
  SMS_PHONE_ALREADY_VERIFIED = 'SMS_PHONE_ALREADY_VERIFIED',
  SMS_SEND_FAILED = 'SMS_SEND_FAILED',

  // Generic errors
  INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR',
}
